import { Component, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-ds-card-badge',
  templateUrl: './ds-card-badge.component.html',
  styleUrls: ['./ds-card-badge.component.scss']
})
export class DsCardBadgeComponent {
  @Input() icon?: string;
  @Input() label?: string;

  private _overlay = false;

  @Input()
  set overlay(value: boolean) {
    const raw = value as unknown;
    this._overlay = raw === '' || raw === true || raw === 'true';
  }
  get overlay(): boolean {
    return this._overlay;
  }

  @HostBinding('class.ds-card__badge') readonly hostClass = true;

  @HostBinding('class.ds-card__badge--overlay')
  get overlayClass(): boolean {
    return this._overlay;
  }
}
